import React, { useEffect, useRef, useState } from 'react'
import CommonTable from '../../../components/comman/CommonTable';
import MainHeading from '../../../components/comman/MainHeading';
import EditIcon from '../../../components/Icons/EditIcon';
import { apiUrl } from '../../../ApiHelper/ApiUrl';
import { callApi } from '../../../ApiHelper/ApiHelper';
import { formatTo12HourTime } from '../../../utility/CommonFunctions';
import { MainFilterHandler } from '../../../components/comman/MainFilterHandler';
import moment from 'moment';
import AddAttendanceRegularizationModal from './AddAttendanceRegularizationModal';
import ViewIcon from '../../../components/Icons/ViewIcon';
import { useNavigate } from 'react-router-dom';
import { RoutesLink } from '../../../ApiHelper/RoutesLink';
import { toast } from 'react-toastify';
import DeleteIcon from '../../../components/Icons/DeleteIcon';
import ConfirmModal from '../../../components/comman/ConfirmModal';
import FilterComponent from '../../../components/comman/FilterComponent';
import { useDispatch, useSelector } from 'react-redux';
import { updateFiltersStates } from '../../../store/actions/UserActions';

export default function UserAr() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const filterDetails = useSelector((state) => state.root.filtersStates);
    const [modal, setModal] = useState({
        updateData: false,
        deleteData: false
    });
    const [state, setState] = useState({
        ArList: [],
        EditArData: null
    })
    const [selectedId, setSelectedId] = useState("");
    const timeoutId = useRef(null);
    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        tableLoader: false,
        filterData: "",
        searchQuery: "",
        sortByDate: [
            moment().subtract(1, "month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
        ],
    });
    const [isLoading, setIsLoading] = useState(false)

    const toggleModal = (type) => {
        setModal((pre) => ({
            ...pre,
            ...(type === 'delete' ? { deleteData: !pre.deleteData } : { updateData: !pre.updateData }),
        }));
    }

    const getMyArReq = (pageNo) => {
        let options = {
            method: "GET",
        };
        const Url = apiUrl.get_ar + '?' + MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy }) + '&myArrequest=true';
        setPageStates((pre) => ({
            ...pre,
            tableLoader: !pre.tableLoader
        }))
        callApi(Url, options).then((res) => {
            setPageStates((pre) => ({
                ...pre,
                tableLoader: !pre.tableLoader
            }))
            if (res?.status === true) {
                const newData = res?.data?.attendance
                    ?.map((item) => ({
                        ...item,
                        createdOn: moment(item?.createdAt).format('DD/MM/YYYY'),
                        checkInTime1: formatTo12HourTime(item?.checkInTime),
                        checkOutTime1: item?.checkOutTime && formatTo12HourTime(item?.checkOutTime),
                        reasonAr: item?.Arrequests[0]?.reason,
                        userName: item?.user?.name,
                        workType: item?.Arrequests[0]?.workType,
                        Arstatus: item?.arRequestStatus,
                        document: item?.Arrequests[0]?.document,
                    }));
                setState((pre) => ({
                    ...pre,
                    ArList: newData,
                }));
                setPageStates((pre) => ({
                    ...pre,
                    count: res?.data?.pageInfo?.total,
                    totalPages: res?.data?.pageInfo?.totalPage,
                }))
            }
        })
    }

    const TableHeading = [
        { value: "index", label: "SR NO." },
        { value: "userName", label: "Name" },
        { value: "createdOn", label: "Created On" },
        { value: "checkInTime1", label: "Check In" },
        { value: "checkOutTime1", label: "Check Out" },
        { value: "reasonAr", label: "Reason" },
        { value: "Arstatus", label: "Status" },
    ];

    const PageChangeHandler = (PageNo) => {
        // console.log("PageChangeHandler", PageNo);
        if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
            setPageStates((prev) => ({
                ...prev,
                currentPage: PageNo,
            }));
        }
    };

    const handleSearchChange = (e) => {
        const { value } = e.target;
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        timeoutId.current = setTimeout(() => {
            setPageStates((prevState) => ({
                ...prevState,
                currentPage: 1,
                searchQuery: value
            }));
        }, 300);
    };

    const handleChangePageSize = (value) => {
        setPageStates((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1
        }));
    };

    useEffect(() => {
        getMyArReq();
    }, [pageStates?.sortByDate, pageStates?.searchQuery, pageStates.pageSize, filterDetails?.orderBy]);

    const handleEdit = (data) => {
        // console.log(data);
        // if (isEndDateGreater(data?.checkOutTime)) {
        setState((pre) => ({ ...pre, EditArData: data }));
        toggleModal();
        // } else {
        //     toast.error('Can not update past leave request.');
        // }
    }

    const ActionHandler = (data) => {
        setSelectedId(data?.id)
        toggleModal('delete');
    }

    const HandleDelete = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl.delete_ar + `?attendanceId=${selectedId}`;
        setIsLoading(true);
        callApi(API, options).then((response) => {
            setIsLoading(false);
            if (response?.status === true) {
                toast.success(response?.message);
                toggleModal('delete');
                getMyArReq();
            } else {
                toast.error(response?.message);
                toggleModal('delete');
            }
        });
    };

    const redirectToView = (data) => {
        navigate(RoutesLink.ar_request_detail + `/${data?.id}`)
    }

    const ActionData = [
        {
            label: "View",
            className: "btn btn-link",
            icon: <ViewIcon />,
            title: "view",
            isShow: 'always',
            clickHandler: redirectToView,
        },
        {
            label: "Edit",
            className: "btn btn-link",
            icon: <EditIcon />,
            title: "edit",
            isShow: 0,
            clickHandler: handleEdit,
        },
        {
            label: "Delete",
            className: "btn btn-link",
            icon: <DeleteIcon />,
            title: "delete",
            isShow: 0,
            clickHandler: ActionHandler,
        },
    ];

    const dateChangeHandler = (Dates) => {
        // console.log(Dates);
        let formattedDate = null;
        if (Dates && Dates.length === 2) {
            const startDate = new Date(
                Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
            )
                .toISOString()
                .slice(0, 10);
            const endDate = new Date(
                Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
            )
                .toISOString()
                .slice(0, 10);
            formattedDate = [startDate, endDate];
        }
        // console.log(formattedDate);
        if (formattedDate !== null) {
            setPageStates((prevState) => ({ ...prevState, sortByDate: formattedDate }))
        } else {
            setPageStates((prevState) => ({ ...prevState, sortByDate: "" }))
        }
    };

    const orderByHandler = (e) => {
        dispatch(
            updateFiltersStates({
                orderBy: e.target.value,
            })
        );
    };

    const orderByList = [
        { value: "", name: "Newest" },
        { value: "asc", name: "Oldest" },
    ];

    return (
        <>
            <div className="content">
                {/* <div className="content-head mb-5 d-flex align-items-start justify-content-between">
                    <h1 className="mb-0">Leave</h1>
                    <button
                        className="btn btn-primary"
                        onClick={() => toggleModal()}
                    >
                        Apply Leave
                    </button>
                </div> */}
                <MainHeading
                    title={"Attendance Regularization"}
                    buttonText={"Apply Att. Regularization"}
                    dateChangeHandler={dateChangeHandler}
                    // buttonIcon={<PlusIcon />}
                    // buttonLink={RoutesLink?.add_customer}
                    clickHandler={toggleModal}
                />
                {/* <TopLable items={topLabelItems} /> */}
                <div className="card mb-4">
                    <div className="card-body">
                        <FilterComponent
                            // handleFilterForLeave={setPageStates}
                            // FilterData={pageStates}
                            handleSearch={handleSearchChange}
                            orderByHandler={orderByHandler}
                            orderByList={orderByList}
                        />
                        <CommonTable
                            TableHeading={TableHeading}
                            TableData={state?.ArList}
                            ActionData={ActionData}
                            currentPage={pageStates?.currentPage}
                            PageChangeHandler={PageChangeHandler}
                            isLoading={pageStates?.tableLoader}
                            totalPages={pageStates?.totalPages}
                            count={pageStates?.count}
                            handleChangePageSize={handleChangePageSize}
                            pageSize={pageStates.pageSize}
                        />
                    </div>
                </div>
            </div>
            <AddAttendanceRegularizationModal isOpen={modal?.updateData} onClose={toggleModal} EditArData={state?.EditArData} setState={setState} getAr={getMyArReq} />
            <ConfirmModal
                modal={modal.deleteData}
                toggle={() => toggleModal('delete')}
                submitHandler={HandleDelete}
                isLoading={isLoading}
            />
        </>
    )
}
